import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateSurveyConnectivityAs2MutationVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
  surveyAgreementConnectivityAs2: Types.SurveyAgreementConnectivityAs2;
}>;


export type UpdateSurveyConnectivityAs2Mutation = { __typename?: 'Mutation', updateSurveyConnectivityAs2: { __typename?: 'SurveyResponse', response?: string | null } };

export type UpdateSurveyContactMutationVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
  surveyContact: Types.SurveyContactInput;
}>;


export type UpdateSurveyContactMutation = { __typename?: 'Mutation', updateSurveyContact: { __typename?: 'SurveyContactResponse', surveyContactId?: number | null, surveyId?: number | null, contactTypeId?: number | null, contactFirstName?: string | null, contactLastName?: string | null, contactNumber?: string | null, contactEmailAddres?: string | null, contactComment?: string | null, insertUser?: string | null, insertTime?: string | null, updateUser?: string | null, updateTime?: string | null, groupId?: string | null } };

export type UpdateSurveyConnectivitySmtpMutationVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
  surveyConnectivitySMTP: Types.SurveyConnectivitySmtpInput;
}>;


export type UpdateSurveyConnectivitySmtpMutation = { __typename?: 'Mutation', updateSurveyConnectivitySmtp: { __typename?: 'SurveyConnectivitySMTPResponse', surveyConnectivityId?: number | null, surveyId?: number | null, environment?: string | null, partnerInboundMessageSubject?: string | null, partnerInboundMessageTo?: string | null, partnerInboundMessageCC?: string | null, partnerInboundMessageDataFileInEmailBody?: boolean | null, partnerInboundAttachmentFilenameRequirements?: string | null, partnerInboundEmailBodyText?: string | null, partnerInboundMaximumEmailSizeMegaBytes?: number | null, partnerOutboundMessageFrom?: string | null, partnerOutboundMessageSubject?: string | null, partnerOutboundMessageDataFileInEmailBody?: boolean | null, partnerInboundMessageSubjectComment?: string | null, partnerInboundMessageToComment?: string | null, partnerInboundMessageCCComment?: string | null, partnerInboundMessageDataFileInEmailBodyComment?: string | null, partnerInboundAttachmentFilenameRequirementsComment?: string | null, partnerInboundEmailBodyTextComment?: string | null, partnerInboundMaximumEmailSizeMegaBytesComment?: string | null, partnerOutboundMessageFromComment?: string | null, partnerOutboundMessageSubjectComment?: string | null, partnerOutboundMessageDataFileInEmailBodyComment?: string | null, additionalInfo?: string | null, insertUser?: string | null, insertTime?: string | null, updateUser?: string | null, updateTime?: string | null, groupId?: string | null } };

export type UpdateSurveyConnectivityOftp2MutationVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
  surveyConnectivityOFTP2: Types.SurveyConnectivityOftp2Input;
}>;


export type UpdateSurveyConnectivityOftp2Mutation = { __typename?: 'Mutation', updateSurveyConnectivityOftp2: { __typename?: 'SurveyConnectivityOFTP2Response', surveyConnectivityId?: number | null, surveyId?: number | null, environment?: string | null, fileExchangeMode?: string | null, serverAddress?: string | null, serverPort?: number | null, sSIDCode?: string | null, passwordAvailable?: boolean | null, useTLS?: boolean | null, useCryptographicAuthentication?: boolean | null, certificateAvailable?: boolean | null, providerPushSFIDDestination?: string | null, providerPushSFIDDSNVFN?: string | null, providerPushAdvancedCompression?: boolean | null, providerPushDataFormat?: string | null, providerPushFixedLength?: number | null, providerPushEnryptOrSign?: string | null, providerPushEnryptionAlgorithm?: string | null, providerPushEERP?: boolean | null, partnerPullSFIDDSNVFN?: string | null, partnerPullDataFormat?: string | null, partnerPullFixedLength?: number | null, partnerPullAdvancedCompression?: boolean | null, partnerPullEnryptOrSign?: string | null, partnerPullEnryptionAlgorithm?: string | null, partnerPullEERP?: boolean | null, providerPullFrequency?: string | null, providerPullEnrypted?: boolean | null, providerPullSigning?: string | null, partnerPushFileTypes?: string | null, partnerPushNonEDIOriginator?: string | null, partnerPushNonEDIRecipient?: string | null, partnerPushNonEDIAPRF?: string | null, partnerPushVFN?: string | null, providerPushSFIDDestinationComment?: string | null, providerPushSFIDDSNVFNComment?: string | null, providerPushAdvancedCompressionComment?: string | null, providerPushDataFormatComment?: string | null, providerPushFixedLengthComment?: string | null, providerPushEnryptOrSignComment?: string | null, providerPushEnryptionAlgorithmComment?: string | null, providerPushSigningAlgorithm?: string | null, providerPushSigningAlgorithmComment?: string | null, providerPushEERPComment?: string | null, partnerPullSFIDDSNVFNComment?: string | null, partnerPullDataFormatComment?: string | null, partnerPullFixedLengthComment?: string | null, partnerPullAdvancedCompressionComment?: string | null, partnerPullEnryptOrSignComment?: string | null, partnerPullEnryptionAlgorithmComment?: string | null, partnerPullEERPComment?: string | null, providerPullFrequencyComment?: string | null, providerPullEnryptedComment?: string | null, providerPullSigningComment?: string | null, partnerPushFileTypesComment?: string | null, partnerPushNonEDIOriginatorComment?: string | null, partnerPushNonEDIRecipientComment?: string | null, partnerPushNonEDIAPRFComment?: string | null, partnerPushVFNComment?: string | null, additionalInfo?: string | null, insertUser?: string | null, insertTime?: string | null, updateUser?: string | null, updateTime?: string | null, certificateAvailableComment?: string | null, fileExchangeModeComment?: string | null, serverAddressComment?: string | null, serverPortComment?: string | null, sSIDCodeComment?: string | null, passwordAvailableComment?: string | null, useTLSComment?: string | null, useCryptographicAuthenticationComment?: string | null, groupId?: string | null } };

export type UploadBlobFileMutationVariables = Types.Exact<{
  blobFile: Types.BlobFileInput;
}>;


export type UploadBlobFileMutation = { __typename?: 'Mutation', uploadBlobFile: { __typename?: 'TFBlobResponse', blobId?: number | null, downloadLink?: string | null, fileName?: string | null, mimeType?: string | null, requiresAuthentication?: boolean | null, rolesAllowed?: string | null, insertUser?: string | null, insertTime?: string | null, updateUser?: string | null, updateTime?: string | null } };

export type SaveConnectivityTestFileMutationVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
  testFile: Types.SurveyConnectivityTestFileInput;
}>;


export type SaveConnectivityTestFileMutation = { __typename?: 'Mutation', saveConnectivityTestFile: Array<{ __typename?: 'SurveyConnectivityTestFileReport', rowId?: number | null, processCode?: string | null, processCodeName?: string | null, documentFormat?: string | null, currentVersionNumber?: string | null, processCodeId?: number | null, documentFormatId?: number | null, testFileId?: number | null, surveyId?: number | null, groupId?: string | null, versionNumber?: string | null, fileBlobId?: number | null, fileStatus?: string | null, fileError?: string | null, submittedForValidation?: string | null, validationReference?: string | null, validationStatus?: string | null, validationPassed?: string | null, validationResultBlobId?: number | null, surveyValidationStatusDescr?: string | null, validationStatusPhraseId?: string | null, insertTime?: string | null, subList?: Array<{ __typename?: 'SurveyConnectivityTestFileReport', rowId?: number | null, processCode?: string | null, processCodeName?: string | null, documentFormat?: string | null, currentVersionNumber?: string | null, processCodeId?: number | null, documentFormatId?: number | null, testFileId?: number | null, surveyId?: number | null, groupId?: string | null, versionNumber?: string | null, fileBlobId?: number | null, fileStatus?: string | null, fileError?: string | null, submittedForValidation?: string | null, validationReference?: string | null, validationStatus?: string | null, validationPassed?: string | null, validationResultBlobId?: number | null, surveyValidationStatusDescr?: string | null, validationStatusPhraseId?: string | null, insertTime?: string | null }> | null }> };

export type UpdateNotificationReadDataMutationVariables = Types.Exact<{
  authentication: Types.Scalars['String']['input'];
  notificationInput: Array<Types.NotificationInput> | Types.NotificationInput;
}>;


export type UpdateNotificationReadDataMutation = { __typename?: 'Mutation', updateNotificationReadData: { __typename?: 'NotificationUpdateResponse', response?: string | null } };

export type AddBannerDataMutationVariables = Types.Exact<{
  authentication: Types.Scalars['String']['input'];
  addBannerInput: Types.AddBannerInput;
}>;


export type AddBannerDataMutation = { __typename?: 'Mutation', addBannerData: { __typename?: 'AddBannerResponse', response?: string | null } };

export type EditBannerDataMutationVariables = Types.Exact<{
  authentication: Types.Scalars['String']['input'];
  bannerEditRequest: Types.BannerEditRequest;
}>;


export type EditBannerDataMutation = { __typename?: 'Mutation', editBannerData: { __typename?: 'EditBannerResponse', response?: string | null } };

export type DeleteBannerDataMutationVariables = Types.Exact<{
  authentication: Types.Scalars['String']['input'];
  bannerId: Types.Scalars['Float']['input'];
}>;


export type DeleteBannerDataMutation = { __typename?: 'Mutation', deleteBannerData: { __typename?: 'DeleteBannerResponse', response?: string | null } };

export type CreateSurveyMutationVariables = Types.Exact<{
  surveyCreateRequests: Array<Types.SurveyCreateRequest> | Types.SurveyCreateRequest;
}>;


export type CreateSurveyMutation = { __typename?: 'Mutation', createSurvey?: Array<{ __typename?: 'SurveyCreateResult', success?: string | null, surveyId?: number | null, errorText?: string | null, groupId?: string | null }> | null };

export type CreateSurveyFromMasterSurveyMutationVariables = Types.Exact<{
  copySurveyRequest: Types.CopySurveyRequest;
}>;


export type CreateSurveyFromMasterSurveyMutation = { __typename?: 'Mutation', createSurveyFromMasterSurvey?: Array<{ __typename?: 'SurveyCreateResult', success?: string | null, surveyId?: number | null, errorText?: string | null, groupId?: string | null }> | null };

export type SaveConnectivityPeppolDetailsForSurveyMutationVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
  peppolDetails: Types.SurveyConnectivityPeppolInput;
}>;


export type SaveConnectivityPeppolDetailsForSurveyMutation = { __typename?: 'Mutation', saveConnectivityPeppolDetailsForSurvey: { __typename?: 'SurveyConnectivityPeppolResponse', environment?: string | null, groupId?: string | null, insertTime?: string | null, insertUser?: string | null, receivingPeppolId?: string | null, receivingPeppolIdComment?: string | null, sendingPeppolId?: string | null, sendingPeppolIdComment?: string | null, surveyConnectivityId?: number | null, surveyID?: number | null, updateTime?: string | null, updateUser?: string | null } };

export type CreateNotificationTemplateDataMutationVariables = Types.Exact<{
  authentication: Types.Scalars['String']['input'];
  notificationTemplateInput: Array<Types.NotificationTemplateInput> | Types.NotificationTemplateInput;
}>;


export type CreateNotificationTemplateDataMutation = { __typename?: 'Mutation', createNotificationTemplateData: { __typename?: 'NotificationTemplateResponse', response?: string | null } };

export type AddNotificationDataMutationVariables = Types.Exact<{
  authentication: Types.Scalars['String']['input'];
  addNotificationInput: Array<Types.AddNotificationInput> | Types.AddNotificationInput;
}>;


export type AddNotificationDataMutation = { __typename?: 'Mutation', addNotificationData: { __typename?: 'AddNotificationResponse', response?: string | null } };

export type EditNotificationDataMutationVariables = Types.Exact<{
  authentication: Types.Scalars['String']['input'];
  notificationEditRequest: Types.NotificationEditRequest;
}>;


export type EditNotificationDataMutation = { __typename?: 'Mutation', editNotificationData: { __typename?: 'EditNotificationResponse', response?: string | null } };


export const UpdateSurveyConnectivityAs2Document = gql`
    mutation updateSurveyConnectivityAs2($groupId: String!, $surveyAgreementConnectivityAs2: SurveyAgreementConnectivityAs2!) {
  updateSurveyConnectivityAs2(
    groupId: $groupId
    surveyAgreementConnectivityAs2: $surveyAgreementConnectivityAs2
  ) {
    response
  }
}
    `;
export type UpdateSurveyConnectivityAs2MutationFn = Apollo.MutationFunction<UpdateSurveyConnectivityAs2Mutation, UpdateSurveyConnectivityAs2MutationVariables>;

/**
 * __useUpdateSurveyConnectivityAs2Mutation__
 *
 * To run a mutation, you first call `useUpdateSurveyConnectivityAs2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyConnectivityAs2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyConnectivityAs2Mutation, { data, loading, error }] = useUpdateSurveyConnectivityAs2Mutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      surveyAgreementConnectivityAs2: // value for 'surveyAgreementConnectivityAs2'
 *   },
 * });
 */
export function useUpdateSurveyConnectivityAs2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyConnectivityAs2Mutation, UpdateSurveyConnectivityAs2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyConnectivityAs2Mutation, UpdateSurveyConnectivityAs2MutationVariables>(UpdateSurveyConnectivityAs2Document, options);
      }
export type UpdateSurveyConnectivityAs2MutationHookResult = ReturnType<typeof useUpdateSurveyConnectivityAs2Mutation>;
export type UpdateSurveyConnectivityAs2MutationResult = Apollo.MutationResult<UpdateSurveyConnectivityAs2Mutation>;
export type UpdateSurveyConnectivityAs2MutationOptions = Apollo.BaseMutationOptions<UpdateSurveyConnectivityAs2Mutation, UpdateSurveyConnectivityAs2MutationVariables>;
export const UpdateSurveyContactDocument = gql`
    mutation updateSurveyContact($groupId: String!, $surveyContact: SurveyContactInput!) {
  updateSurveyContact(groupId: $groupId, surveyContact: $surveyContact) {
    surveyContactId
    surveyId
    contactTypeId
    contactFirstName
    contactLastName
    contactNumber
    contactEmailAddres
    contactComment
    insertUser
    insertTime
    updateUser
    updateTime
    groupId
  }
}
    `;
export type UpdateSurveyContactMutationFn = Apollo.MutationFunction<UpdateSurveyContactMutation, UpdateSurveyContactMutationVariables>;

/**
 * __useUpdateSurveyContactMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyContactMutation, { data, loading, error }] = useUpdateSurveyContactMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      surveyContact: // value for 'surveyContact'
 *   },
 * });
 */
export function useUpdateSurveyContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyContactMutation, UpdateSurveyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyContactMutation, UpdateSurveyContactMutationVariables>(UpdateSurveyContactDocument, options);
      }
export type UpdateSurveyContactMutationHookResult = ReturnType<typeof useUpdateSurveyContactMutation>;
export type UpdateSurveyContactMutationResult = Apollo.MutationResult<UpdateSurveyContactMutation>;
export type UpdateSurveyContactMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyContactMutation, UpdateSurveyContactMutationVariables>;
export const UpdateSurveyConnectivitySmtpDocument = gql`
    mutation updateSurveyConnectivitySmtp($groupId: String!, $surveyConnectivitySMTP: SurveyConnectivitySMTPInput!) {
  updateSurveyConnectivitySmtp(
    groupId: $groupId
    surveyConnectivitySMTP: $surveyConnectivitySMTP
  ) {
    surveyConnectivityId
    surveyId
    environment
    partnerInboundMessageSubject
    partnerInboundMessageTo
    partnerInboundMessageCC
    partnerInboundMessageDataFileInEmailBody
    partnerInboundAttachmentFilenameRequirements
    partnerInboundEmailBodyText
    partnerInboundMaximumEmailSizeMegaBytes
    partnerOutboundMessageFrom
    partnerOutboundMessageSubject
    partnerOutboundMessageDataFileInEmailBody
    partnerInboundMessageSubjectComment
    partnerInboundMessageToComment
    partnerInboundMessageCCComment
    partnerInboundMessageDataFileInEmailBodyComment
    partnerInboundAttachmentFilenameRequirementsComment
    partnerInboundEmailBodyTextComment
    partnerInboundMaximumEmailSizeMegaBytesComment
    partnerOutboundMessageFromComment
    partnerOutboundMessageSubjectComment
    partnerOutboundMessageDataFileInEmailBodyComment
    additionalInfo
    insertUser
    insertTime
    updateUser
    updateTime
    groupId
  }
}
    `;
export type UpdateSurveyConnectivitySmtpMutationFn = Apollo.MutationFunction<UpdateSurveyConnectivitySmtpMutation, UpdateSurveyConnectivitySmtpMutationVariables>;

/**
 * __useUpdateSurveyConnectivitySmtpMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyConnectivitySmtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyConnectivitySmtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyConnectivitySmtpMutation, { data, loading, error }] = useUpdateSurveyConnectivitySmtpMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      surveyConnectivitySMTP: // value for 'surveyConnectivitySMTP'
 *   },
 * });
 */
export function useUpdateSurveyConnectivitySmtpMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyConnectivitySmtpMutation, UpdateSurveyConnectivitySmtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyConnectivitySmtpMutation, UpdateSurveyConnectivitySmtpMutationVariables>(UpdateSurveyConnectivitySmtpDocument, options);
      }
export type UpdateSurveyConnectivitySmtpMutationHookResult = ReturnType<typeof useUpdateSurveyConnectivitySmtpMutation>;
export type UpdateSurveyConnectivitySmtpMutationResult = Apollo.MutationResult<UpdateSurveyConnectivitySmtpMutation>;
export type UpdateSurveyConnectivitySmtpMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyConnectivitySmtpMutation, UpdateSurveyConnectivitySmtpMutationVariables>;
export const UpdateSurveyConnectivityOftp2Document = gql`
    mutation updateSurveyConnectivityOftp2($groupId: String!, $surveyConnectivityOFTP2: SurveyConnectivityOFTP2Input!) {
  updateSurveyConnectivityOftp2(
    groupId: $groupId
    surveyConnectivityOFTP2: $surveyConnectivityOFTP2
  ) {
    surveyConnectivityId
    surveyId
    environment
    fileExchangeMode
    serverAddress
    serverPort
    sSIDCode
    passwordAvailable
    useTLS
    useCryptographicAuthentication
    certificateAvailable
    providerPushSFIDDestination
    providerPushSFIDDSNVFN
    providerPushAdvancedCompression
    providerPushDataFormat
    providerPushFixedLength
    providerPushEnryptOrSign
    providerPushEnryptionAlgorithm
    providerPushEERP
    partnerPullSFIDDSNVFN
    partnerPullDataFormat
    partnerPullFixedLength
    partnerPullAdvancedCompression
    partnerPullEnryptOrSign
    partnerPullEnryptionAlgorithm
    partnerPullEERP
    providerPullFrequency
    providerPullEnrypted
    providerPullSigning
    partnerPushFileTypes
    partnerPushNonEDIOriginator
    partnerPushNonEDIRecipient
    partnerPushNonEDIAPRF
    partnerPushVFN
    providerPushSFIDDestinationComment
    providerPushSFIDDSNVFNComment
    providerPushAdvancedCompressionComment
    providerPushDataFormatComment
    providerPushFixedLengthComment
    providerPushEnryptOrSignComment
    providerPushEnryptionAlgorithmComment
    providerPushSigningAlgorithm
    providerPushSigningAlgorithmComment
    providerPushEERPComment
    partnerPullSFIDDSNVFNComment
    partnerPullDataFormatComment
    partnerPullFixedLengthComment
    partnerPullAdvancedCompressionComment
    partnerPullEnryptOrSignComment
    partnerPullEnryptionAlgorithmComment
    partnerPullEERPComment
    providerPullFrequencyComment
    providerPullEnryptedComment
    providerPullSigningComment
    partnerPushFileTypesComment
    partnerPushNonEDIOriginatorComment
    partnerPushNonEDIRecipientComment
    partnerPushNonEDIAPRFComment
    partnerPushVFNComment
    additionalInfo
    insertUser
    insertTime
    updateUser
    updateTime
    certificateAvailableComment
    fileExchangeModeComment
    serverAddressComment
    serverPortComment
    sSIDCodeComment
    passwordAvailableComment
    useTLSComment
    useCryptographicAuthenticationComment
    groupId
  }
}
    `;
export type UpdateSurveyConnectivityOftp2MutationFn = Apollo.MutationFunction<UpdateSurveyConnectivityOftp2Mutation, UpdateSurveyConnectivityOftp2MutationVariables>;

/**
 * __useUpdateSurveyConnectivityOftp2Mutation__
 *
 * To run a mutation, you first call `useUpdateSurveyConnectivityOftp2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyConnectivityOftp2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyConnectivityOftp2Mutation, { data, loading, error }] = useUpdateSurveyConnectivityOftp2Mutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      surveyConnectivityOFTP2: // value for 'surveyConnectivityOFTP2'
 *   },
 * });
 */
export function useUpdateSurveyConnectivityOftp2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyConnectivityOftp2Mutation, UpdateSurveyConnectivityOftp2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyConnectivityOftp2Mutation, UpdateSurveyConnectivityOftp2MutationVariables>(UpdateSurveyConnectivityOftp2Document, options);
      }
export type UpdateSurveyConnectivityOftp2MutationHookResult = ReturnType<typeof useUpdateSurveyConnectivityOftp2Mutation>;
export type UpdateSurveyConnectivityOftp2MutationResult = Apollo.MutationResult<UpdateSurveyConnectivityOftp2Mutation>;
export type UpdateSurveyConnectivityOftp2MutationOptions = Apollo.BaseMutationOptions<UpdateSurveyConnectivityOftp2Mutation, UpdateSurveyConnectivityOftp2MutationVariables>;
export const UploadBlobFileDocument = gql`
    mutation uploadBlobFile($blobFile: BlobFileInput!) {
  uploadBlobFile(blobFile: $blobFile) {
    blobId
    downloadLink
    fileName
    mimeType
    requiresAuthentication
    rolesAllowed
    insertUser
    insertTime
    updateUser
    updateTime
  }
}
    `;
export type UploadBlobFileMutationFn = Apollo.MutationFunction<UploadBlobFileMutation, UploadBlobFileMutationVariables>;

/**
 * __useUploadBlobFileMutation__
 *
 * To run a mutation, you first call `useUploadBlobFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBlobFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBlobFileMutation, { data, loading, error }] = useUploadBlobFileMutation({
 *   variables: {
 *      blobFile: // value for 'blobFile'
 *   },
 * });
 */
export function useUploadBlobFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadBlobFileMutation, UploadBlobFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadBlobFileMutation, UploadBlobFileMutationVariables>(UploadBlobFileDocument, options);
      }
export type UploadBlobFileMutationHookResult = ReturnType<typeof useUploadBlobFileMutation>;
export type UploadBlobFileMutationResult = Apollo.MutationResult<UploadBlobFileMutation>;
export type UploadBlobFileMutationOptions = Apollo.BaseMutationOptions<UploadBlobFileMutation, UploadBlobFileMutationVariables>;
export const SaveConnectivityTestFileDocument = gql`
    mutation saveConnectivityTestFile($groupId: String!, $testFile: SurveyConnectivityTestFileInput!) {
  saveConnectivityTestFile(groupId: $groupId, testFile: $testFile) {
    rowId
    processCode
    processCodeName
    documentFormat
    currentVersionNumber
    processCodeId
    documentFormatId
    testFileId
    surveyId
    groupId
    versionNumber
    fileBlobId
    fileStatus
    fileError
    submittedForValidation
    validationReference
    validationStatus
    validationPassed
    validationResultBlobId
    surveyValidationStatusDescr
    validationStatusPhraseId
    insertTime
    subList {
      rowId
      processCode
      processCodeName
      documentFormat
      currentVersionNumber
      processCodeId
      documentFormatId
      testFileId
      surveyId
      groupId
      versionNumber
      fileBlobId
      fileStatus
      fileError
      submittedForValidation
      validationReference
      validationStatus
      validationPassed
      validationResultBlobId
      surveyValidationStatusDescr
      validationStatusPhraseId
      insertTime
    }
  }
}
    `;
export type SaveConnectivityTestFileMutationFn = Apollo.MutationFunction<SaveConnectivityTestFileMutation, SaveConnectivityTestFileMutationVariables>;

/**
 * __useSaveConnectivityTestFileMutation__
 *
 * To run a mutation, you first call `useSaveConnectivityTestFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveConnectivityTestFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveConnectivityTestFileMutation, { data, loading, error }] = useSaveConnectivityTestFileMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      testFile: // value for 'testFile'
 *   },
 * });
 */
export function useSaveConnectivityTestFileMutation(baseOptions?: Apollo.MutationHookOptions<SaveConnectivityTestFileMutation, SaveConnectivityTestFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveConnectivityTestFileMutation, SaveConnectivityTestFileMutationVariables>(SaveConnectivityTestFileDocument, options);
      }
export type SaveConnectivityTestFileMutationHookResult = ReturnType<typeof useSaveConnectivityTestFileMutation>;
export type SaveConnectivityTestFileMutationResult = Apollo.MutationResult<SaveConnectivityTestFileMutation>;
export type SaveConnectivityTestFileMutationOptions = Apollo.BaseMutationOptions<SaveConnectivityTestFileMutation, SaveConnectivityTestFileMutationVariables>;
export const UpdateNotificationReadDataDocument = gql`
    mutation updateNotificationReadData($authentication: String!, $notificationInput: [NotificationInput!]!) {
  updateNotificationReadData(
    authentication: $authentication
    notificationInput: $notificationInput
  ) {
    response
  }
}
    `;
export type UpdateNotificationReadDataMutationFn = Apollo.MutationFunction<UpdateNotificationReadDataMutation, UpdateNotificationReadDataMutationVariables>;

/**
 * __useUpdateNotificationReadDataMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationReadDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationReadDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationReadDataMutation, { data, loading, error }] = useUpdateNotificationReadDataMutation({
 *   variables: {
 *      authentication: // value for 'authentication'
 *      notificationInput: // value for 'notificationInput'
 *   },
 * });
 */
export function useUpdateNotificationReadDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationReadDataMutation, UpdateNotificationReadDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationReadDataMutation, UpdateNotificationReadDataMutationVariables>(UpdateNotificationReadDataDocument, options);
      }
export type UpdateNotificationReadDataMutationHookResult = ReturnType<typeof useUpdateNotificationReadDataMutation>;
export type UpdateNotificationReadDataMutationResult = Apollo.MutationResult<UpdateNotificationReadDataMutation>;
export type UpdateNotificationReadDataMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationReadDataMutation, UpdateNotificationReadDataMutationVariables>;
export const AddBannerDataDocument = gql`
    mutation addBannerData($authentication: String!, $addBannerInput: AddBannerInput!) {
  addBannerData(authentication: $authentication, addBannerInput: $addBannerInput) {
    response
  }
}
    `;
export type AddBannerDataMutationFn = Apollo.MutationFunction<AddBannerDataMutation, AddBannerDataMutationVariables>;

/**
 * __useAddBannerDataMutation__
 *
 * To run a mutation, you first call `useAddBannerDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBannerDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBannerDataMutation, { data, loading, error }] = useAddBannerDataMutation({
 *   variables: {
 *      authentication: // value for 'authentication'
 *      addBannerInput: // value for 'addBannerInput'
 *   },
 * });
 */
export function useAddBannerDataMutation(baseOptions?: Apollo.MutationHookOptions<AddBannerDataMutation, AddBannerDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBannerDataMutation, AddBannerDataMutationVariables>(AddBannerDataDocument, options);
      }
export type AddBannerDataMutationHookResult = ReturnType<typeof useAddBannerDataMutation>;
export type AddBannerDataMutationResult = Apollo.MutationResult<AddBannerDataMutation>;
export type AddBannerDataMutationOptions = Apollo.BaseMutationOptions<AddBannerDataMutation, AddBannerDataMutationVariables>;
export const EditBannerDataDocument = gql`
    mutation editBannerData($authentication: String!, $bannerEditRequest: BannerEditRequest!) {
  editBannerData(
    authentication: $authentication
    bannerEditRequest: $bannerEditRequest
  ) {
    response
  }
}
    `;
export type EditBannerDataMutationFn = Apollo.MutationFunction<EditBannerDataMutation, EditBannerDataMutationVariables>;

/**
 * __useEditBannerDataMutation__
 *
 * To run a mutation, you first call `useEditBannerDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBannerDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBannerDataMutation, { data, loading, error }] = useEditBannerDataMutation({
 *   variables: {
 *      authentication: // value for 'authentication'
 *      bannerEditRequest: // value for 'bannerEditRequest'
 *   },
 * });
 */
export function useEditBannerDataMutation(baseOptions?: Apollo.MutationHookOptions<EditBannerDataMutation, EditBannerDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBannerDataMutation, EditBannerDataMutationVariables>(EditBannerDataDocument, options);
      }
export type EditBannerDataMutationHookResult = ReturnType<typeof useEditBannerDataMutation>;
export type EditBannerDataMutationResult = Apollo.MutationResult<EditBannerDataMutation>;
export type EditBannerDataMutationOptions = Apollo.BaseMutationOptions<EditBannerDataMutation, EditBannerDataMutationVariables>;
export const DeleteBannerDataDocument = gql`
    mutation deleteBannerData($authentication: String!, $bannerId: Float!) {
  deleteBannerData(authentication: $authentication, bannerId: $bannerId) {
    response
  }
}
    `;
export type DeleteBannerDataMutationFn = Apollo.MutationFunction<DeleteBannerDataMutation, DeleteBannerDataMutationVariables>;

/**
 * __useDeleteBannerDataMutation__
 *
 * To run a mutation, you first call `useDeleteBannerDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBannerDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBannerDataMutation, { data, loading, error }] = useDeleteBannerDataMutation({
 *   variables: {
 *      authentication: // value for 'authentication'
 *      bannerId: // value for 'bannerId'
 *   },
 * });
 */
export function useDeleteBannerDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBannerDataMutation, DeleteBannerDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBannerDataMutation, DeleteBannerDataMutationVariables>(DeleteBannerDataDocument, options);
      }
export type DeleteBannerDataMutationHookResult = ReturnType<typeof useDeleteBannerDataMutation>;
export type DeleteBannerDataMutationResult = Apollo.MutationResult<DeleteBannerDataMutation>;
export type DeleteBannerDataMutationOptions = Apollo.BaseMutationOptions<DeleteBannerDataMutation, DeleteBannerDataMutationVariables>;
export const CreateSurveyDocument = gql`
    mutation createSurvey($surveyCreateRequests: [SurveyCreateRequest!]!) {
  createSurvey(surveyCreateRequests: $surveyCreateRequests) {
    success
    surveyId
    errorText
    groupId
  }
}
    `;
export type CreateSurveyMutationFn = Apollo.MutationFunction<CreateSurveyMutation, CreateSurveyMutationVariables>;

/**
 * __useCreateSurveyMutation__
 *
 * To run a mutation, you first call `useCreateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveyMutation, { data, loading, error }] = useCreateSurveyMutation({
 *   variables: {
 *      surveyCreateRequests: // value for 'surveyCreateRequests'
 *   },
 * });
 */
export function useCreateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<CreateSurveyMutation, CreateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSurveyMutation, CreateSurveyMutationVariables>(CreateSurveyDocument, options);
      }
export type CreateSurveyMutationHookResult = ReturnType<typeof useCreateSurveyMutation>;
export type CreateSurveyMutationResult = Apollo.MutationResult<CreateSurveyMutation>;
export type CreateSurveyMutationOptions = Apollo.BaseMutationOptions<CreateSurveyMutation, CreateSurveyMutationVariables>;
export const CreateSurveyFromMasterSurveyDocument = gql`
    mutation createSurveyFromMasterSurvey($copySurveyRequest: CopySurveyRequest!) {
  createSurveyFromMasterSurvey(copySurveyRequest: $copySurveyRequest) {
    success
    surveyId
    errorText
    groupId
  }
}
    `;
export type CreateSurveyFromMasterSurveyMutationFn = Apollo.MutationFunction<CreateSurveyFromMasterSurveyMutation, CreateSurveyFromMasterSurveyMutationVariables>;

/**
 * __useCreateSurveyFromMasterSurveyMutation__
 *
 * To run a mutation, you first call `useCreateSurveyFromMasterSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyFromMasterSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveyFromMasterSurveyMutation, { data, loading, error }] = useCreateSurveyFromMasterSurveyMutation({
 *   variables: {
 *      copySurveyRequest: // value for 'copySurveyRequest'
 *   },
 * });
 */
export function useCreateSurveyFromMasterSurveyMutation(baseOptions?: Apollo.MutationHookOptions<CreateSurveyFromMasterSurveyMutation, CreateSurveyFromMasterSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSurveyFromMasterSurveyMutation, CreateSurveyFromMasterSurveyMutationVariables>(CreateSurveyFromMasterSurveyDocument, options);
      }
export type CreateSurveyFromMasterSurveyMutationHookResult = ReturnType<typeof useCreateSurveyFromMasterSurveyMutation>;
export type CreateSurveyFromMasterSurveyMutationResult = Apollo.MutationResult<CreateSurveyFromMasterSurveyMutation>;
export type CreateSurveyFromMasterSurveyMutationOptions = Apollo.BaseMutationOptions<CreateSurveyFromMasterSurveyMutation, CreateSurveyFromMasterSurveyMutationVariables>;
export const SaveConnectivityPeppolDetailsForSurveyDocument = gql`
    mutation saveConnectivityPeppolDetailsForSurvey($groupId: String!, $peppolDetails: SurveyConnectivityPeppolInput!) {
  saveConnectivityPeppolDetailsForSurvey(
    groupId: $groupId
    peppolDetails: $peppolDetails
  ) {
    environment
    groupId
    insertTime
    insertUser
    receivingPeppolId
    receivingPeppolIdComment
    sendingPeppolId
    sendingPeppolIdComment
    surveyConnectivityId
    surveyID
    updateTime
    updateUser
  }
}
    `;
export type SaveConnectivityPeppolDetailsForSurveyMutationFn = Apollo.MutationFunction<SaveConnectivityPeppolDetailsForSurveyMutation, SaveConnectivityPeppolDetailsForSurveyMutationVariables>;

/**
 * __useSaveConnectivityPeppolDetailsForSurveyMutation__
 *
 * To run a mutation, you first call `useSaveConnectivityPeppolDetailsForSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveConnectivityPeppolDetailsForSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveConnectivityPeppolDetailsForSurveyMutation, { data, loading, error }] = useSaveConnectivityPeppolDetailsForSurveyMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      peppolDetails: // value for 'peppolDetails'
 *   },
 * });
 */
export function useSaveConnectivityPeppolDetailsForSurveyMutation(baseOptions?: Apollo.MutationHookOptions<SaveConnectivityPeppolDetailsForSurveyMutation, SaveConnectivityPeppolDetailsForSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveConnectivityPeppolDetailsForSurveyMutation, SaveConnectivityPeppolDetailsForSurveyMutationVariables>(SaveConnectivityPeppolDetailsForSurveyDocument, options);
      }
export type SaveConnectivityPeppolDetailsForSurveyMutationHookResult = ReturnType<typeof useSaveConnectivityPeppolDetailsForSurveyMutation>;
export type SaveConnectivityPeppolDetailsForSurveyMutationResult = Apollo.MutationResult<SaveConnectivityPeppolDetailsForSurveyMutation>;
export type SaveConnectivityPeppolDetailsForSurveyMutationOptions = Apollo.BaseMutationOptions<SaveConnectivityPeppolDetailsForSurveyMutation, SaveConnectivityPeppolDetailsForSurveyMutationVariables>;
export const CreateNotificationTemplateDataDocument = gql`
    mutation createNotificationTemplateData($authentication: String!, $notificationTemplateInput: [NotificationTemplateInput!]!) {
  createNotificationTemplateData(
    authentication: $authentication
    notificationTemplateInput: $notificationTemplateInput
  ) {
    response
  }
}
    `;
export type CreateNotificationTemplateDataMutationFn = Apollo.MutationFunction<CreateNotificationTemplateDataMutation, CreateNotificationTemplateDataMutationVariables>;

/**
 * __useCreateNotificationTemplateDataMutation__
 *
 * To run a mutation, you first call `useCreateNotificationTemplateDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationTemplateDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationTemplateDataMutation, { data, loading, error }] = useCreateNotificationTemplateDataMutation({
 *   variables: {
 *      authentication: // value for 'authentication'
 *      notificationTemplateInput: // value for 'notificationTemplateInput'
 *   },
 * });
 */
export function useCreateNotificationTemplateDataMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationTemplateDataMutation, CreateNotificationTemplateDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationTemplateDataMutation, CreateNotificationTemplateDataMutationVariables>(CreateNotificationTemplateDataDocument, options);
      }
export type CreateNotificationTemplateDataMutationHookResult = ReturnType<typeof useCreateNotificationTemplateDataMutation>;
export type CreateNotificationTemplateDataMutationResult = Apollo.MutationResult<CreateNotificationTemplateDataMutation>;
export type CreateNotificationTemplateDataMutationOptions = Apollo.BaseMutationOptions<CreateNotificationTemplateDataMutation, CreateNotificationTemplateDataMutationVariables>;
export const AddNotificationDataDocument = gql`
    mutation addNotificationData($authentication: String!, $addNotificationInput: [AddNotificationInput!]!) {
  addNotificationData(
    authentication: $authentication
    addNotificationInput: $addNotificationInput
  ) {
    response
  }
}
    `;
export type AddNotificationDataMutationFn = Apollo.MutationFunction<AddNotificationDataMutation, AddNotificationDataMutationVariables>;

/**
 * __useAddNotificationDataMutation__
 *
 * To run a mutation, you first call `useAddNotificationDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNotificationDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNotificationDataMutation, { data, loading, error }] = useAddNotificationDataMutation({
 *   variables: {
 *      authentication: // value for 'authentication'
 *      addNotificationInput: // value for 'addNotificationInput'
 *   },
 * });
 */
export function useAddNotificationDataMutation(baseOptions?: Apollo.MutationHookOptions<AddNotificationDataMutation, AddNotificationDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNotificationDataMutation, AddNotificationDataMutationVariables>(AddNotificationDataDocument, options);
      }
export type AddNotificationDataMutationHookResult = ReturnType<typeof useAddNotificationDataMutation>;
export type AddNotificationDataMutationResult = Apollo.MutationResult<AddNotificationDataMutation>;
export type AddNotificationDataMutationOptions = Apollo.BaseMutationOptions<AddNotificationDataMutation, AddNotificationDataMutationVariables>;
export const EditNotificationDataDocument = gql`
    mutation editNotificationData($authentication: String!, $notificationEditRequest: NotificationEditRequest!) {
  editNotificationData(
    authentication: $authentication
    notificationEditRequest: $notificationEditRequest
  ) {
    response
  }
}
    `;
export type EditNotificationDataMutationFn = Apollo.MutationFunction<EditNotificationDataMutation, EditNotificationDataMutationVariables>;

/**
 * __useEditNotificationDataMutation__
 *
 * To run a mutation, you first call `useEditNotificationDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditNotificationDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editNotificationDataMutation, { data, loading, error }] = useEditNotificationDataMutation({
 *   variables: {
 *      authentication: // value for 'authentication'
 *      notificationEditRequest: // value for 'notificationEditRequest'
 *   },
 * });
 */
export function useEditNotificationDataMutation(baseOptions?: Apollo.MutationHookOptions<EditNotificationDataMutation, EditNotificationDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditNotificationDataMutation, EditNotificationDataMutationVariables>(EditNotificationDataDocument, options);
      }
export type EditNotificationDataMutationHookResult = ReturnType<typeof useEditNotificationDataMutation>;
export type EditNotificationDataMutationResult = Apollo.MutationResult<EditNotificationDataMutation>;
export type EditNotificationDataMutationOptions = Apollo.BaseMutationOptions<EditNotificationDataMutation, EditNotificationDataMutationVariables>;